{
  "#COUPONS": {
    "TITLE": "Gutscheinkarte",
    "GENERIC_ERROR_TITLE": "Prüfung fehlgeschlagen",
    "GENERIC_ERROR": "Es ist ein unerwarteter Fehler aufgetreten!",
    "SUCCESS_REDEEM": "Gutschein wurde erfolgreich eingelöst",
    "SUCCESS_CHARGE": "Gutschein wurde erfolgreich aufgeladen",
    "INVALID_CODE": "Ungültiger Gutscheincode",
    "STARTPAGE": {
      "MANUAL_INPUT": "Manuelle Eingabe",
      "START_BTN": "Start",
      "OR": "oder",
      "SCAN_COUPON": "Gutscheinkarte scannen",
      "SCAN_DESCRIPTION": "Tippen Sie hier um die Kamera zu starten und einen Barcode einer Gutscheinkarte zu scannen.",
      "LOADING": "Bitte Warten",
      "LOADING_DESC": "Gutscheincode wird geprüft"
    },
    "EXISTING_PAGE": {
      "HEADER": {
        "TITLE": "Vorhandene Gutscheinkarte",
        "INFO": {
          "DESCRIPTION": "Die Gutscheinkarte wurde erkannt. Wollen Sie die erkannte Karte einlösen oder aufladen?",
          "BALANCE": "Aktueller Saldo"
        }
      },
      "REDEEM": {
        "TITLE": "Gutscheinkarte einlösen",
        "DESCRIPTION": "Tippen Sie hier um einen Betrag von der erkannten Gutscheinkarte einzulösen."
      },
      "CHARGE": {
        "TITLE": "Gutscheinkarte aufladen",
        "DESCRIPTION": "Tippen Sie hier um einen Betrag auf die erkannte Gutscheinkarte aufzuladen."
      },
      "FOOTER": {
        "INFO": "Wählen Sie bitte ein Aktion aus um fortzufahren",
        "CANCEL_BTN": "Abbrechen"
      }
    },
    "CHARGE_PAGE": {
      "HEADER": {
        "TITLE": "Vorhandene Gutscheinkarte",
        "TITLE_NEW": "Neue Gutscheinkarte",
        "INFO": {
          "DESCRIPTION": "Die Gutscheinkarte wurde erkannt. Bitte wählen Sie einen Betrag aus oder geben Sie manuell einen Betrag ein.",
          "DESCRIPTION_NEW": "Die Gutscheinkarte ist noch nicht bekannt. Bitte wählen Sie einen Betrag aus den Vorschlägen aus oder geben Sie manuell den gewünschten Betrag ein.",
          "BALANCE": "Aktueller Saldo"
        }
      },
      "FORM": {
        "TITLE": "Aufladen",
        "SUGGESTIONS": {
          "TITLE": "Vorschläge"
        },
        "MANUAL_INPUT": {
          "TITLE": "Manuelle Eingabe",
          "PLACEHOLDER": "Betrag in Euro"
        }
      },
      "SELECTED_SECTION": {
        "HEADING_AMOUNT": "Ausgewählter Betrag",
        "SALDO_DESCRIPTION": "Saldo nach dem Aufladen:"
      },
      "BUTTONS": {
        "CANCEL": "Aufladen abbrechen",
        "CHARGE": "Gutscheinkarte aufladen"
      }
    },
    "REDEEM_PAGE": {
      "HEADER": {
        "TITLE": "Vorhandene Gutscheinkarte",
        "INFO": {
          "DESCRIPTION": "Die Gutscheinkarte wurde erkannt. Bitte wählen Sie einen Betrag aus oder nutzen Sie die manuelle Eingabe.",
          "BALANCE": "Aktueller Saldo"
        }
      },
      "FORM": {
        "TITLE": "Einlösen",
        "SUGGESTIONS": {
          "TITLE": "Vorschläge"
        },
        "MANUAL_INPUT": {
          "TITLE": "Manuelle Eingabe",
          "PLACEHOLDER": "Betrag in Euro",
          "ERROR": "Der eingegebene Betrag darf nicht größer als der verfügbare Betrag der Gutscheinkarte sein",
          "ERROR_SUBJECT": "Falscher Betrag"
        },
        "DEBIT_FULL": "Gesamten Gutschein einlösen"
      },
      "SELECTED_SECTION": {
        "HEADING_AMOUNT": "Ausgewählter Betrag",
        "SALDO_DESCRIPTION": "Saldo nach dem Einlösen:"
      },
      "BUTTONS": {
        "CANCEL": "Einlösen abbrechen",
        "REDEEM": "Gutscheinkarte einlösen"
      }
    },
    "DAILY_BALANCE": {
      "TITLE": "Tagesbilanz",
      "OVERVIEW": {
        "TITLE_REDEEM": "Eingelöst",
        "TITLE_CHARGE": "Aufgeladen"
      },
      "LIST": {
        "HEADER": "Alle Transaktionen",
        "LABEL_REDEEM": "Eingelöst",
        "LABEL_CHARGE": "Aufgeladen",
        "TOTAL_LABEL": "Gesamtwert"
      }
    },
    "DIALOGS": {
      "CONFIRM": {
        "HEADER_REDEEM": "Abbuchen bestätigen",
        "HEADER_CHARGE": "Aufladen bestätigen",
        "BODY_REDEEM": "Wollen Sie wirklich {{amount}} EUR von der Gutscheinkarte abbuchen?",
        "BODY_CHARGE": "Wollen Sie wirklich {{amount}} EUR auf die Gutscheinkarte aufladen?",
        "OK": "OK",
        "CANCEL": "Abbrechen"
      }
    }
  }
}
